import React from "react";
import {
  Typography,
  Box,
  Paper,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  CircularProgress,
  Chip,
  Button,
  Table,
  TableBody,
  TableRow,
  TableCell,
  Collapse,
  Tabs,
  Tab,
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormControlLabel,
  Switch,
  InputAdornment,
  Divider,
  Tooltip,
  Popover,
} from "@mui/material";
import {
  Save,
  Print,
  Edit,
  Assignment,
  Category,
  DoneAll,
  GetApp,
  PersonAdd,
  Payment,
  ExpandMore,
  Delete,
  Info,
  Close,
  Visibility,
  Settings,
  RemoveCircle,
  DriveFileRenameOutline,
  FormatBold,
  FormatItalic,
  FormatUnderlined,
  FormatColorFill,
  FormatColorText,
  FormatListBulleted,
  FormatListNumbered,
  FormatAlignLeft,
  FormatAlignCenter,
  FormatAlignRight,
  FormatAlignJustify,
  FormatIndentIncrease,
  FormatIndentDecrease,
  TableChart,
  FormatClear,
} from "@mui/icons-material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import { utils, writeFileXLSX } from "xlsx";
import { GroupPassengersSection } from "./GroupPassengersSection";
import { printGroupPackage, printDeudores } from "./GroupPrintTemplate";
import { PassengerPaymentDialog } from "./PassengerPaymentDialog";

interface ProductDetailSheetProps {
  open: boolean;
  onClose: () => void;
  productoSeleccionado: any;
  palette: any;
  logo: any;
  category?: string;
  actualizarProductoSeleccionado: (actualizador: (prev: any) => any) => void;
  guardarCambios: () => Promise<void>;
  guardandoCambios: boolean;
  nuevoPasajero: any;
  setNuevoPasajero: (val: any) => void;
  eliminarPasajero: (pasajero: any) => Promise<void>;
  onAddPassenger: (nuevo: any) => void;
  onUpdatePassenger: (pasajeroEditado: any) => Promise<void>;
  onFinalizar: (id: number) => Promise<void>;
  onDeleteProduct: (id: number) => void;
  onOpenPagos: (product: any) => void;
  onAddPagoPasajero?: (pasajero: any, data: any) => Promise<void>;
  onUpdatePagoPasajero?: (id: number, data: any) => Promise<void>;
  onDeletePagoPasajero?: (id: number) => Promise<void>;
  onToggleRevisadoPagoPasajero?: (id: number, checked: boolean, fecha?: string) => Promise<void>;
}

const REQUISITOS_OPCIONES = [
  "Datos del pagador", "Colegio", "e-mail", "Bolso", "Dirección", "Teléfono", "Celular 1",
  "Celular 2", "Firmó", "Pagó", "Fecha de firma", "Foto Visa", "Monto de Pago", "Emisión",
  "Permiso", "Partida de nacimiento", "Vacuna", "DNI Físico", "Fotocopia de DNI", "Talle", "Ficha Médica",
  "VISA", "Pasaporte europeo", "Pasaporte", "CUIL"
];

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const TabPanel: React.FC<TabPanelProps> = ({ children, value, index, ...other }) => (
  <div role="tabpanel" hidden={value !== index} {...other}>
    {value === index && <Box sx={{ p: 2 }}>{children}</Box>}
  </div>
);

export const ProductDetailSheet: React.FC<ProductDetailSheetProps> = ({
  open,
  onClose,
  productoSeleccionado,
  palette,
  logo,
  category,
  actualizarProductoSeleccionado,
  guardarCambios,
  guardandoCambios,
  nuevoPasajero,
  setNuevoPasajero,
  eliminarPasajero,
  onAddPassenger,
  onUpdatePassenger,
  onFinalizar,
  onDeleteProduct,
  onOpenPagos,
  onAddPagoPasajero,
  onUpdatePagoPasajero,
  onDeletePagoPasajero,
  onToggleRevisadoPagoPasajero,
}) => {
  const [pasajeroEnPagos, setPasajeroEnPagos] = React.useState<any>(null);

  const getMontoSena = (prod: any) => {
    try {
      const obs = Array.isArray(prod?.observaciones) ? prod.observaciones : JSON.parse(prod?.observaciones || "[]");
      const meta = obs.find((o: any) => o.descripcion?.startsWith("METADATA_GRUPAL:"));
      if (meta) {
        return JSON.parse(meta.descripcion.replace("METADATA_GRUPAL: ", "")).montoSena || 0;
      }
    } catch {}
    return 0;
  };
  const [datosExpanded, setDatosExpanded] = React.useState(true);
  const [pasajerosExpanded, setPasajerosExpanded] = React.useState(true);
  const [editando, setEditando] = React.useState(false);
  const [tabEditValue, setTabEditValue] = React.useState(0);

  // Estado local para el formulario de edición
  const [formData, setFormData] = React.useState<any>(null);

  // Estado para el modal de Subproductos
  const [subproductosDialogOpen, setSubproductosDialogOpen] = React.useState(false);
  const [subproductForm, setSubproductForm] = React.useState({
    nombre: "",
    tipo: "Pago",
    monto: 0,
    moneda: "$",
    clasificacionColectivo: true
  });

  // Estado para el modal de Contratos
  const [contratosDialogOpen, setContratosDialogOpen] = React.useState(false);

  // Estado para el Editor de Contratos
  const [editandoContrato, setEditandoContrato] = React.useState(false);
  const editorRef = React.useRef<HTMLDivElement>(null);
  const textColorRef = React.useRef<HTMLInputElement>(null);
  const bgColorRef = React.useRef<HTMLInputElement>(null);
  const [anchorElTable, setAnchorElTable] = React.useState<HTMLButtonElement | null>(null);
  const [hoverTableSize, setHoverTableSize] = React.useState({ r: 0, c: 0 });
  const [contratos, setContratos] = React.useState<any[]>([
    { id: 1, nombre: "CONTRATO ADHERENTE", cuerpo: `R-ADM-008 00<br/><b>(colegio)</b><br/>Contrato de servicios 15 Forever...` }
  ]);
  const [vistaPreviaDialogOpen, setVistaPreviaDialogOpen] = React.useState(false);
  const [contratoParaVistaPrevia, setContratoParaVistaPrevia] = React.useState<any>(null);
  const [confirmarEliminarOpen, setConfirmarEliminarOpen] = React.useState(false);
  const [idParaEliminar, setIdParaEliminar] = React.useState<number | null>(null);
  const [confirmarFinalizarOpen, setConfirmarFinalizarOpen] = React.useState(false);

  const [contratoForm, setContratoForm] = React.useState({
    id: null,
    nombre: "",
    cuerpo: ""
  });

  // Estado para Diálogo de Exportación Excel
  const [exportDialogOpen, setExportDialogOpen] = React.useState(false);
  const [colectivoSeleccionado, setColectivoSeleccionado] = React.useState("Todos");
  const [camposSeleccionados, setCamposSeleccionados] = React.useState<string[]>([]);

  const EXPORT_FIELDS = [
    "Nombre", "Apellido", "DNI", "Fecha nacimiento", "Datos del pagador", "Colegio", "e-mail",
    "Bolso", "Dirección", "Teléfono fijo", "Celular personal", "Celular contacto 1", "Dueño Celular 1", "Celular contacto 2",
    "Dueño Celular 2", "Firmó", "Pagó", "Fecha de firma", "Foto Visa", "Monto del Contrato", "Saldo a Pagar",
    "Emisión", "Permiso", "Partida de nacimiento", "Vacuna", "DNI o Pasaporte", "DNI Físico", "Fotocopia de DNI",
    "Talle", "Ficha Médica", "VISA", "Pasaporte europeo", "Pasaporte", "CUIL", "Monto Percepción",
    "Saldo Percepción", "Colectivo", "Viaje", "Porcentaje Liberado", "Observación", "Usuario Responsable"
  ];

  const handleToggleTodo = () => {
    if (camposSeleccionados.length === EXPORT_FIELDS.length) setCamposSeleccionados([]);
    else setCamposSeleccionados([...EXPORT_FIELDS]);
  };

  const handleExportarExcel = () => {
    const dataToExport = (productoSeleccionado.pasajerosLista || []).map((p: any) => {
      const row: any = {};
      camposSeleccionados.forEach(campo => {
        // Mapeo simple de campos
        const key = campo.toLowerCase().replace(/ /g, "_");
        row[campo] = p[key] || "";
      });
      return row;
    });

    const wb = utils.book_new();
    const ws = utils.json_to_sheet(dataToExport);
    utils.book_append_sheet(wb, ws, "Pasajeros");
    writeFileXLSX(wb, `Exportacion_${productoSeleccionado.concepto}.xlsx`);
    setExportDialogOpen(false);
  };

  const handleExportarPagos = () => {
    if (!productoSeleccionado) return;
    const pagos = productoSeleccionado.pagos || [];
    const pasajeros = productoSeleccionado.pasajerosLista || [];

    const data = pagos.map((p: any) => {
      // Buscar pasajero por DNI en la observación [PASAJERO:dni]
      const dniMatch = (p.observacion || "").match(/\[PASAJERO:\s*(.*?)\]/);
      const dni = dniMatch ? dniMatch[1] : null;
      const pasajero = dni ? pasajeros.find((px: any) => String(px.dni) === String(dni)) : null;

      let apellido = "-";
      let nombre = "-";
      
      if (pasajero) {
        const parts = (pasajero.nombre || "").split(",");
        apellido = parts[0]?.trim() || "";
        nombre = parts[1]?.trim() || pasajero.nombre;
      } else if ((p.observacion || "").toUpperCase().includes("SEÑA")) {
          nombre = "SEÑA";
          apellido = "GENERAL";
      }

      return {
        "Apellido": apellido,
        "Nombre": nombre,
        "Condición": (p.observacion || "").match(/\[CONDICION:\s*(.*?)\]/)?.[1] || "-",
        "Monto": p.importe,
        "Fecha": p.created_at ? dayjs(p.created_at).format("DD/MM/YYYY") : "-",
        "Concepto": (p.observacion || "").replace(/\[CONDICION:.*?\]/g, "").replace(/\[PASAJERO:.*?\]/g, "").trim() || "-",
        "Responsable": p.responsable_nombre || "-",
        "Revisado": p.revisado_por_nombre ? "SI" : "NO",
        "Revisor": p.revisado_por_nombre || "-",
        "Fecha revisión": p.fecha_revision || "-"
      };
    });

    const wb = utils.book_new();
    const ws = utils.json_to_sheet(data);
    utils.book_append_sheet(wb, ws, "Pagos");
    writeFileXLSX(wb, `Pagos_Grupo_${productoSeleccionado.concepto}.xlsx`);
  };

  const ejecutarComando = (comando: string, valor: string = "") => {
    document.execCommand(comando, false, valor);
  };

  const confirmarInsertarTabla = (rows: number, cols: number) => {
    let htmlTabla = `<table border="1" style="width:100%; border-collapse: collapse; margin-bottom: 15px;">`;
    for (let i = 0; i < rows; i++) {
      htmlTabla += '<tr>';
      for (let j = 0; j < cols; j++) {
        htmlTabla += '<td style="border: 1px solid #ccc; padding: 8px; min-height: 20px;">&nbsp;</td>';
      }
      htmlTabla += '</tr>';
    }
    htmlTabla += '</table><p>&nbsp;</p>';
    ejecutarComando('insertHTML', htmlTabla);
    setAnchorElTable(null);
  };

  // Estado para Configuración de PDF
  const [pdfSettingsDialogOpen, setPdfSettingsDialogOpen] = React.useState(false);
  const [pdfSettings, setPdfSettings] = React.useState({
    margenIzquierdo: 20,
    margenDerecho: 20,
    tamanoLetra: 10
  });

  // Sincronizar formData cuando se entra en modo edición
  React.useEffect(() => {
    if (editando && productoSeleccionado) {
      let metadata: any = {};
      const metadataObs = (productoSeleccionado.observaciones || []).find((o: any) => o.descripcion?.startsWith("METADATA_GRUPAL:"));
      if (metadataObs) {
        try {
          metadata = JSON.parse(metadataObs.descripcion.replace("METADATA_GRUPAL: ", ""));
        } catch (e) {}
      }

      setFormData({
        concepto: productoSeleccionado.concepto || "",
        fechaSalida: productoSeleccionado.fechaSalida ? dayjs(productoSeleccionado.fechaSalida) : null,
        categoria: productoSeleccionado.categoria || category || "otros",
        cantidadColectivos: metadata.cantidadColectivos || 1,
        viajaAlExterior: metadata.viajaAlExterior || false,
        monedaPrincipal: productoSeleccionado.moneda || "USD",
        montoServicio: metadata.montoServicio || 0,
        montoSuplementario: metadata.montoSuplementario || 0,
        percepcion: metadata.percepcion || 0,
        cliente: productoSeleccionado.cliente?.nombre || "",
        telefonoCliente: productoSeleccionado.cliente_telefono || "",
        emailCliente: productoSeleccionado.cliente_correo || "",
        cantidadPasajeros: productoSeleccionado.adultos || 0,
        requisitos: metadata.requisitos || [],
      });
    }
  }, [editando, productoSeleccionado, category]);

  const manejarCambioForm = (campo: string, valor: any) => {
    setFormData((prev: any) => ({ ...prev, [campo]: valor }));
  };

  const toggleRequisito = (requisito: string) => {
    setFormData((prev: any) => {
      const existe = prev.requisitos.includes(requisito);
      const nuevos = existe
        ? prev.requisitos.filter((r: string) => r !== requisito)
        : [...prev.requisitos, requisito];
      return { ...prev, requisitos: nuevos };
    });
  };

  const handlePrint = () => {
    if (!productoSeleccionado) return;
    printGroupPackage(productoSeleccionado, (valor, moneda) => 
      new Intl.NumberFormat('es-AR', { style: 'currency', currency: (moneda === '$' || moneda === 'ARS') ? 'ARS' : 'USD' }).format(valor)
    );
  };

  const handlePrintDeudores = () => {
    if (!productoSeleccionado) return;
    
    const precioVenta = productoSeleccionado.precioVenta || 0;
    const pagos = productoSeleccionado.pagos || [];
    const pasajeros = productoSeleccionado.pasajerosLista || [];

    const deudores = pasajeros.map((p: any) => {
      const pagosDelPasajero = pagos.filter((px: any) => 
        px.observacion && 
        px.observacion.includes(`[PASAJERO:${p.dni}]`) &&
        !px.observacion.toUpperCase().includes("SEÑA")
      );
      
      const totalPagado = pagosDelPasajero.reduce((acc: number, px: any) => acc + (parseFloat(px.importe) || 0), 0);
      const saldo = Math.round((precioVenta - totalPagado) * 100) / 100;

      const parts = (p.nombre || "").split(",");
      const apellido = parts[0]?.trim() || "";
      const nombre_solamente = parts[1]?.trim() || p.nombre;

      return {
        ...p,
        apellido,
        nombre_solamente,
        totalPagado,
        saldo: Math.max(0, saldo),
        precioVenta
      };
    }).filter((p: any) => p.saldo > 0)
      .sort((a: any, b: any) => a.apellido.localeCompare(b.apellido));

    printDeudores(productoSeleccionado, deudores, (valor, moneda) => 
      new Intl.NumberFormat('es-AR', { style: 'currency', currency: (moneda === '$' || moneda === 'ARS') ? 'ARS' : 'USD' }).format(valor)
    );
  };

  const handleExportarDeudoresExcel = () => {
    if (!productoSeleccionado) return;
    
    const precioVenta = productoSeleccionado.precioVenta || 0;
    const pagos = productoSeleccionado.pagos || [];
    const pasajeros = productoSeleccionado.pasajerosLista || [];

    const deudores = pasajeros.map((p: any) => {
      const pagosDelPasajero = pagos.filter((px: any) => 
        px.observacion && 
        px.observacion.includes(`[PASAJERO:${p.dni}]`) &&
        !px.observacion.toUpperCase().includes("SEÑA")
      );
      
      const totalPagado = pagosDelPasajero.reduce((acc: number, px: any) => acc + (parseFloat(px.importe) || 0), 0);
      const saldo = Math.round((precioVenta - totalPagado) * 100) / 100;

      const parts = (p.nombre || "").split(",");
      const apellido = (parts[0]?.trim() || "").toUpperCase();
      const nombre_solamente = (parts[1]?.trim() || p.nombre).toUpperCase();

      return {
        "Apellido": apellido,
        "Nombre": nombre_solamente,
        "Monto Contrato": precioVenta,
        "Pagado": totalPagado,
        "Saldo": Math.max(0, saldo),
        "Monto Total": precioVenta,
        "Pagado Total": totalPagado,
        "Saldo Total": Math.max(0, saldo),
        "Teléfono": p.telefono || "-"
      };
    }).filter((p: any) => p["Saldo"] > 0)
      .sort((a: any, b: any) => (a["Apellido"] || "").localeCompare(b["Apellido"] || ""));

    const wb = utils.book_new();
    const ws = utils.json_to_sheet(deudores);
    utils.book_append_sheet(wb, ws, "Deudores");
    writeFileXLSX(wb, `deudores_${productoSeleccionado.concepto}.xlsx`);
  };

  const handleGuardarEdicion = () => {
    actualizarProductoSeleccionado((prev) => {
      const nuevaMetadata = {
        categoria: formData.categoria,
        viajaAlExterior: formData.viajaAlExterior,
        cantidadColectivos: formData.cantidadColectivos,
        montoServicio: formData.montoServicio,
        montoSuplementario: formData.montoSuplementario,
        percepcion: formData.percepcion,
        cantidadPasajeros: formData.cantidadPasajeros,
        requisitos: formData.requisitos,
        anioViaje: formData.fechaSalida ? formData.fechaSalida.year().toString() : prev.anioViaje,
      };

      const nuevasObs = [...(prev.observaciones || [])];
      const metaIdx = nuevasObs.findIndex(o => o.descripcion?.startsWith("METADATA_GRUPAL:"));
      const metaStr = `METADATA_GRUPAL: ${JSON.stringify(nuevaMetadata)}`;
      
      if (metaIdx !== -1) nuevasObs[metaIdx] = { ...nuevasObs[metaIdx], descripcion: metaStr };
      else nuevasObs.push({ descripcion: metaStr, fecha: dayjs().format("YYYY-MM-DD"), usuario: "SISTEMA" });

      return {
        ...prev,
        concepto: formData.concepto,
        fechaSalida: formData.fechaSalida ? formData.fechaSalida.toDate() : null,
        moneda: formData.monedaPrincipal,
        precioVenta: Number(formData.montoServicio) + Number(formData.montoSuplementario) + Number(formData.percepcion),
        adultos: formData.cantidadPasajeros,
        pasajeros: formData.cantidadPasajeros,
        categoria: formData.categoria,
        observaciones: nuevasObs,
        cliente: {
          ...prev.cliente,
          nombre: formData.cliente,
        },
        cliente_telefono: formData.telefonoCliente,
        cliente_correo: formData.emailCliente,
      };
    });
    setEditando(false);
  };

  if (!productoSeleccionado) return null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xl"
      fullWidth
      PaperProps={{ sx: { borderRadius: 3, bgcolor: "#fbfbfb" } }}
    >
      <DialogTitle sx={{ p: 0, borderBottom: 1, borderColor: "divider" }}>
        <Box
          sx={{
            p: 3,
            textAlign: "center",
            background: palette.gradient,
            color: "white",
          }}
        >
          <Typography
            variant="h4"
            sx={{
              fontWeight: 800,
              color: "white",
              letterSpacing: "-0.5px",
              textShadow: "0 2px 4px rgba(0,0,0,0.2)",
            }}
          >
            {productoSeleccionado?.concepto?.toUpperCase()}
          </Typography>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              gap: 2,
              alignItems: "center",
              mt: 2,
            }}
          >
            <DatePicker
              label="Salida"
              views={["year"]}
              openTo="year"
              value={
                productoSeleccionado?.fechaSalida
                  ? dayjs(productoSeleccionado.fechaSalida)
                  : null
              }
              onChange={(val) =>
                actualizarProductoSeleccionado((prev) => ({
                  ...prev,
                  fechaSalida: val ? val.toDate() : null,
                  anioViaje: val ? val.year().toString() : "",
                }))
              }
              slotProps={{
                textField: {
                  size: "small",
                  sx: {
                    width: 130,
                    bgcolor: "rgba(255,255,255,0.1)",
                    "& .MuiInputBase-input": { color: "white" },
                    "& .MuiInputLabel-root": {
                      color: "rgba(255,255,255,0.7)",
                    },
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderColor: "rgba(255,255,255,0.3)",
                    },
                  },
                },
              }}
            />
          </Box>
        </Box>
      </DialogTitle>

      <DialogContent sx={{ px: 4, pb: 4 }}>
        {/* SECCIÓN: DATOS DEL PRODUCTO */}
        <Box
          sx={{
            background: palette.gradient,
            color: "white",
            p: 1.5,
            mt: 2,
            mb: 1,
            borderRadius: datosExpanded ? "8px 8px 0 0" : "8px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            cursor: 'pointer',
            transition: 'border-radius 0.3s'
          }}
          onClick={() => setDatosExpanded(!datosExpanded)}
        >
          <Typography sx={{ fontWeight: 700, ml: 1 }}>
            Datos del producto
          </Typography>
          <Box sx={{ display: "flex", gap: 0.5 }}>
            <Button
              size="small"
              color="inherit"
              startIcon={<Edit sx={{ fontSize: 18 }} />}
              sx={{ textTransform: "none", fontWeight: 600 }}
              onClick={(e) => {
                e.stopPropagation();
                setEditando(!editando);
                if (!editando) setDatosExpanded(true);
              }}
            >
              {editando ? "Cancelar" : "Editar"}
            </Button>
            <Button
              size="small"
              color="inherit"
              startIcon={<Category sx={{ fontSize: 18 }} />}
              sx={{ textTransform: "none", fontWeight: 600 }}
              onClick={(e) => {
                e.stopPropagation();
                setSubproductosDialogOpen(true);
              }}
            >
              Subproductos
            </Button>
            <Button
              size="small"
              color="inherit"
              startIcon={<Assignment sx={{ fontSize: 18 }} />}
              sx={{ textTransform: "none", fontWeight: 600 }}
              onClick={(e) => {
                e.stopPropagation();
                setContratosDialogOpen(true);
              }}
            >
              Contratos
            </Button>
            <Button
              size="small"
              color="inherit"
              startIcon={<DoneAll sx={{ fontSize: 18 }} />}
              sx={{ textTransform: "none", fontWeight: 600 }}
              onClick={(e) => {
                e.stopPropagation();
                setConfirmarFinalizarOpen(true);
              }}
            >
              Finalizar
            </Button>
            <Button
              size="small"
              color="inherit"
              startIcon={<GetApp sx={{ fontSize: 18 }} />}
              onClick={(e) => {
                e.stopPropagation();
                setExportDialogOpen(true);
              }}
              sx={{ textTransform: "none", fontWeight: 600 }}
            >
              Exportar
            </Button>
            <Button
              size="small"
              color="inherit"
              startIcon={<Print sx={{ fontSize: 18 }} />}
              onClick={(e) => {
                e.stopPropagation();
                handlePrint();
              }}
              sx={{ textTransform: "none", fontWeight: 600 }}
            >
              Imprimir
            </Button>
            <Button
              size="small"
              color="inherit"
              startIcon={<Delete sx={{ fontSize: 18 }} />}
              sx={{ textTransform: "none", fontWeight: 600 }}
              onClick={(e) => {
                e.stopPropagation();
                onDeleteProduct(productoSeleccionado.id);
              }}
            >
              Eliminar
            </Button>
            <IconButton 
              size="small" 
              color="inherit"
              sx={{ 
                transition: 'transform 0.3s',
                transform: datosExpanded ? 'rotate(0deg)' : 'rotate(-90deg)'
              }}
            >
              <ExpandMore />
            </IconButton>
          </Box>
        </Box>
        
        <Collapse in={datosExpanded}>
          <Paper
            elevation={0}
            sx={{
              p: 0,
              mb: 4,
              border: "1px solid",
              borderColor: "divider",
              borderRadius: "0 0 8px 8px",
              borderTop: 0,
              overflow: "hidden",
              bgcolor: editando ? "white" : "inherit"
            }}
          >
            {editando && formData ? (
              <Box sx={{ p: 0 }}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider', bgcolor: '#f8f9fa' }}>
                  <Tabs value={tabEditValue} onChange={(_, v) => setTabEditValue(v)} variant="fullWidth">
                    <Tab label="1. Destino" />
                    <Tab label="2. Montos" />
                    <Tab label="3. Clientes" />
                  </Tabs>
                </Box>

                <TabPanel value={tabEditValue} index={0}>
                  <Grid container spacing={2} sx={{ p: 1 }}>
                    <Grid item xs={12} md={8}>
                      <TextField label="Nombre del Grupo / Concepto" fullWidth size="small" value={formData.concepto} onChange={(e) => manejarCambioForm('concepto', e.target.value)} />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <DatePicker 
                        label="Año de salida" 
                        views={['year']}
                        value={formData.fechaSalida} 
                        onChange={(v) => manejarCambioForm('fechaSalida', v)} 
                        slotProps={{ textField: { fullWidth: true, size: 'small' } }} 
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <FormControl fullWidth size="small">
                        <InputLabel>Tipo de producto</InputLabel>
                        <Select 
                          value={formData.categoria} 
                          label="Tipo de producto"
                          onChange={(e) => manejarCambioForm('categoria', e.target.value)}
                        >
                          <MenuItem value="quince">Quinceañeras</MenuItem>
                          <MenuItem value="egresados">Egresados</MenuItem>
                          <MenuItem value="educativos">Educativos</MenuItem>
                          <MenuItem value="eventos">Eventos</MenuItem>
                          <MenuItem value="otros">Otros</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <TextField label="Cant. Colectivos" type="number" fullWidth size="small" value={formData.cantidadColectivos} onChange={(e) => manejarCambioForm('cantidadColectivos', parseInt(e.target.value) || 0)} />
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <FormControlLabel control={<Switch size="small" checked={formData.viajaAlExterior} onChange={(e) => manejarCambioForm('viajaAlExterior', e.target.checked)} />} label="¿Al exterior?" />
                    </Grid>
                  </Grid>
                </TabPanel>

                <TabPanel value={tabEditValue} index={1}>
                  <Grid container spacing={2} sx={{ p: 1 }}>
                    <Grid item xs={12} md={6}>
                      <FormControl fullWidth size="small">
                        <InputLabel>Moneda</InputLabel>
                        <Select value={formData.monedaPrincipal} label="Moneda" onChange={(e) => manejarCambioForm('monedaPrincipal', e.target.value)}>
                          <MenuItem value="ARS">Pesos (ARS)</MenuItem>
                          <MenuItem value="USD">Dólares (USD)</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <TextField 
                        label="Monto servicio" 
                        type="number" 
                        fullWidth 
                        size="small"
                        value={formData.montoServicio} 
                        onChange={(e) => manejarCambioForm('montoServicio', parseFloat(e.target.value) || 0)} 
                        InputProps={{ startAdornment: <InputAdornment position="start">{formData.monedaPrincipal === 'USD' ? 'U$D' : '$'}</InputAdornment> }} 
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <TextField label="Monto suplementario" type="number" fullWidth size="small" value={formData.montoSuplementario} onChange={(e) => manejarCambioForm('montoSuplementario', parseFloat(e.target.value) || 0)} />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <TextField label="Percepción" type="number" fullWidth size="small" value={formData.percepcion} onChange={(e) => manejarCambioForm('percepcion', parseFloat(e.target.value) || 0)} />
                    </Grid>
                    <Grid item xs={12}>
                      <Box sx={{ p: 1, bgcolor: '#f8f9fa', borderRadius: 1, textAlign: 'right', border: '1px dashed #ccc' }}>
                        <Typography variant="body2" color="text.secondary">Total Calculado</Typography>
                        <Typography variant="h6" color="primary.main" sx={{ fontWeight: 700 }}>
                          {formData.monedaPrincipal === 'USD' ? 'U$D' : '$'} {(Number(formData.montoServicio) + Number(formData.montoSuplementario) + Number(formData.percepcion)).toLocaleString()}
                        </Typography>
                      </Box>
                    </Grid>
                  </Grid>
                </TabPanel>

                <TabPanel value={tabEditValue} index={2}>
                  <Grid container spacing={2} sx={{ p: 1 }}>
                    <Grid item xs={12} md={6}><TextField label="Nombre Responsable" fullWidth size="small" value={formData.cliente} onChange={(e) => manejarCambioForm('cliente', e.target.value)} /></Grid>
                    <Grid item xs={12} md={3}><TextField label="Teléfono" fullWidth size="small" value={formData.telefonoCliente} onChange={(e) => manejarCambioForm('telefonoCliente', e.target.value)} /></Grid>
                    <Grid item xs={12} md={3}><TextField label="Email" fullWidth size="small" value={formData.emailCliente} onChange={(e) => manejarCambioForm('emailCliente', e.target.value)} /></Grid>
                    <Grid item xs={12} md={4}>
                      <TextField label="Cantidad de pasajeros" type="number" fullWidth size="small" value={formData.cantidadPasajeros} onChange={(e) => manejarCambioForm('cantidadPasajeros', parseInt(e.target.value) || 0)} />
                    </Grid>
                    <Grid item xs={12}>
                      <Divider sx={{ my: 1 }} />
                      <Typography variant="caption" sx={{ mb: 1, display: 'block', fontWeight: 600 }}>Requisitos de datos:</Typography>
                      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                        {REQUISITOS_OPCIONES.map((req) => (
                          <Chip
                            key={req}
                            label={req}
                            size="small"
                            variant={formData.requisitos.includes(req) ? "filled" : "outlined"}
                            onClick={() => toggleRequisito(req)}
                            color={formData.requisitos.includes(req) ? "primary" : "default"}
                            sx={{ fontSize: '0.7rem' }}
                          />
                        ))}
                      </Box>
                    </Grid>
                  </Grid>
                </TabPanel>

                <Box sx={{ p: 2, display: 'flex', justifyContent: 'flex-end', gap: 2, bgcolor: '#fdfdfd', borderTop: '1px solid #eee' }}>
                  <Button size="small" onClick={() => setEditando(false)}>Cerrar</Button>
                  <Button size="small" variant="contained" color="primary" onClick={handleGuardarEdicion}>Aplicar cambios locales</Button>
                </Box>
              </Box>
            ) : (
              <Table size="small">
                <TableBody>
                  {[
                  {
                    label: "Año de salida",
                    value: productoSeleccionado?.anioViaje || "-",
                  },
                  {
                    label: "Tipo",
                    value:
                      category === "quince"
                        ? "Quinceañeras"
                        : category === "egresados"
                          ? "Egresados"
                          : category === "educativos"
                            ? "Educativos"
                            : category === "eventos"
                              ? "Eventos"
                              : "Otros",
                  },
                  {
                    label: "Monto total del producto",
                    value: `${productoSeleccionado?.moneda === "USD" ? "U$S" : "$"} ${productoSeleccionado?.precioVenta || 0}`,
                  },
                  {
                    label: "Cupo de pasajeros",
                    value: productoSeleccionado?.adultos || 0,
                  },
                  {
                    label: "Pasajeros cargados",
                    value: productoSeleccionado?.pasajerosLista?.length || 0,
                  },
                  {
                    label: "Pasajeros que viajan",
                    value: productoSeleccionado?.pasajerosLista?.filter((p: any) => Boolean(p.viaja)).length ?? 0,
                  },
                ].map((row, index) => (
                  <TableRow
                    key={index}
                    sx={{
                      bgcolor: index % 2 === 0 ? palette.light : "white",
                    }}
                  >
                    <TableCell
                      sx={{
                        fontWeight: 600,
                        color: "#444",
                        width: "30%",
                        borderBottom: "1px solid #eee",
                        py: 1.5,
                      }}
                    >
                      {row.label}
                    </TableCell>
                    <TableCell
                      sx={{
                        color: "#666",
                        borderBottom: "1px solid #eee",
                        py: 1.5,
                      }}
                    >
                      {row.value}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            )}
          </Paper>
        </Collapse>

        {/* SECCIÓN: PASAJEROS */}
        <Box
          sx={{
            background: palette.gradient,
            color: "white",
            p: 1.5,
            mb: 1,
            borderRadius: pasajerosExpanded ? "8px 8px 0 0" : "8px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            cursor: 'pointer',
            transition: 'border-radius 0.3s'
          }}
          onClick={() => setPasajerosExpanded(!pasajerosExpanded)}
        >
          <Typography sx={{ fontWeight: 700, ml: 1 }}>Pasajeros</Typography>
          <Box sx={{ display: "flex", gap: 0.5 }}>
            <Button
              size="small"
              color="inherit"
              startIcon={<PersonAdd sx={{ fontSize: 18 }} />}
              disabled
              sx={{ textTransform: "none", fontWeight: 600 }}
              onClick={(e) => e.stopPropagation()}
            >
              Agregar Pasajero (En desarrollo)
            </Button>
            <Button
              size="small"
              color="inherit"
              startIcon={<Payment sx={{ fontSize: 18 }} />}
              sx={{ textTransform: "none", fontWeight: 600 }}
              onClick={(e) => {
                e.stopPropagation();
                handleExportarPagos();
              }}
            >
              Exportar Pagos
            </Button>
            <Button
              size="small"
              color="inherit"
              startIcon={<Print sx={{ fontSize: 18 }} />}
              sx={{ textTransform: "none", fontWeight: 600 }}
              onClick={(e) => {
                e.stopPropagation();
                handlePrintDeudores();
              }}
            >
              Imprimir deudores
            </Button>
            <Button
              size="small"
              color="inherit"
              startIcon={<GetApp sx={{ fontSize: 18 }} />}
              sx={{ textTransform: "none", fontWeight: 600 }}
              onClick={(e) => {
                e.stopPropagation();
                handleExportarDeudoresExcel();
              }}
            >
              Exportar Deudores a Excel
            </Button>
            <Button
              size="small"
              color="inherit"
              startIcon={<Info sx={{ fontSize: 18 }} />}
              sx={{ textTransform: "none", fontWeight: 600 }}
              onClick={(e) => e.stopPropagation()}
            >
              Informe de cancelación
            </Button>
            <IconButton 
              size="small" 
              color="inherit"
              sx={{ 
                transition: 'transform 0.3s',
                transform: pasajerosExpanded ? 'rotate(0deg)' : 'rotate(-90deg)'
              }}
            >
              <ExpandMore />
            </IconButton>
          </Box>
        </Box>
        
        <Collapse in={pasajerosExpanded}>
          <Paper
            elevation={0}
            sx={{
              p: 0,
              mb: 4,
              border: "1px solid",
              borderColor: "divider",
              borderRadius: "0 0 8px 8px",
              borderTop: 0,
              overflow: "hidden",
            }}
          >
            <GroupPassengersSection
              pasajeros={productoSeleccionado?.pasajerosLista || []}
              nuevoPasajero={nuevoPasajero}
              setNuevoPasajero={setNuevoPasajero}
              eliminarPasajero={eliminarPasajero}
              paqueteId={productoSeleccionado?.id || 0}
              precioVenta={productoSeleccionado?.precioVenta || 0}
              pagos={productoSeleccionado?.pagos || []}
              onAddPassenger={onAddPassenger}
              onUpdatePassenger={onUpdatePassenger}
              onOpenPagos={(pasajero) => setPasajeroEnPagos(pasajero)}
              palette={palette}
              tripName={productoSeleccionado?.concepto?.toUpperCase()}
              tripYear={productoSeleccionado?.anioViaje || dayjs(productoSeleccionado?.fechaSalida).year().toString()}
              packageType={
                category === "quince" ? "QUINCE" :
                category === "egresados" ? "EGRESADOS" :
                category === "educativos" ? "EDUCATIVOS" :
                category === "eventos" ? "EVENTOS" : "GRUPALES"
              }
            />
          </Paper>
        </Collapse>

        {pasajeroEnPagos && (
          <PassengerPaymentDialog
            open={!!pasajeroEnPagos}
            onClose={() => setPasajeroEnPagos(null)}
            pasajero={pasajeroEnPagos}
            producto={productoSeleccionado}
            pagos={productoSeleccionado?.pagos || []}
            montoSena={getMontoSena(productoSeleccionado)}
            onAddPago={onAddPagoPasajero!}
            onUpdatePago={onUpdatePagoPasajero!}
            onDeletePago={onDeletePagoPasajero!}
            onToggleRevisado={onToggleRevisadoPagoPasajero!}
            onUpdatePassenger={onUpdatePassenger}
          />
        )}

        <Box
          sx={{
            px: 3,
            py: 2,
            mb: 4,
            bgcolor: palette.light,
            display: "flex",
            justifyContent: "flex-end",
            border: "1px solid",
            borderColor: "divider",
            borderTop: 0,
            borderRadius: "0 0 8px 8px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              bgcolor: "white",
              borderRadius: 1,
              overflow: "hidden",
              border: "1px solid",
              borderColor: palette.main,
            }}
          >
            <Typography
              sx={{
                px: 2,
                py: 1,
                bgcolor: palette.main,
                color: "white",
                fontWeight: 700,
                fontSize: "0.9rem",
              }}
            >
              Saldo total
            </Typography>
            <Typography
              sx={{
                px: 3,
                py: 1,
                fontWeight: 800,
                color: palette.main,
                fontSize: "1.1rem",
              }}
            >
              {productoSeleccionado?.moneda === "USD" ? "U$D" : "$"}{" "}
              {(
                productoSeleccionado?.precioVenta || 0
              ).toLocaleString("es-AR", { minimumFractionDigits: 2 })}
            </Typography>
          </Box>
        </Box>
      </DialogContent>

      <DialogActions sx={{ p: 3, borderTop: 1, borderColor: "divider" }}>
        <Button onClick={onClose} variant="outlined">
          Cerrar
        </Button>
        <Box sx={{ display: "flex", gap: 2 }}>
          <Button
            variant="contained"
            color="success"
            startIcon={
              guardandoCambios ? (
                <CircularProgress size={20} color="inherit" />
              ) : (
                <Save />
              )
            }
            onClick={guardarCambios}
            disabled={guardandoCambios}
          >
            Guardar
          </Button>
          <Button
            variant="contained"
            startIcon={<Print />}
            onClick={handlePrint}
          >
            Imprimir
          </Button>
        </Box>
      </DialogActions>

      {/* MODAL DE SUBPRODUCTOS */}
      <Dialog 
        open={subproductosDialogOpen} 
        onClose={() => setSubproductosDialogOpen(false)}
        maxWidth="md"
        fullWidth
        PaperProps={{ sx: { borderRadius: 2 } }}
      >
        <DialogTitle sx={{ m: 0, p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #eee' }}>
          <Typography variant="h6" sx={{ fontWeight: 600, color: '#666' }}>
            Subproductos | {productoSeleccionado?.concepto?.toUpperCase()}
          </Typography>
          <IconButton onClick={() => setSubproductosDialogOpen(false)} size="small">
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ p: 4 }}>
          <Typography variant="subtitle1" sx={{ mb: 4, textAlign: 'center', color: '#666' }}>
            Agregar Subproductos
          </Typography>
          
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Typography variant="caption" sx={{ fontWeight: 700, mb: 1, display: 'block', color: '#444' }}>Nombre del subproducto</Typography>
              <TextField 
                fullWidth 
                size="small" 
                value={subproductForm.nombre}
                onChange={(e) => setSubproductForm({...subproductForm, nombre: e.target.value})}
              />
            </Grid>

            <Grid item xs={12}>
              <Typography variant="caption" sx={{ fontWeight: 700, mb: 1, display: 'block', color: '#444' }}>Tipo de subproducto</Typography>
              <FormControl fullWidth size="small">
                <Select 
                  value={subproductForm.tipo}
                  onChange={(e) => setSubproductForm({...subproductForm, tipo: e.target.value})}
                >
                  <MenuItem value="Pago">Pago</MenuItem>
                  <MenuItem value="Cuenta">Cuenta</MenuItem>
                  <MenuItem value="Opciones Bariloche">Opciones Bariloche</MenuItem>
                  <MenuItem value="Opciones Camboriu">Opciones Camboriu</MenuItem>
                  <MenuItem value="Fiesta">Fiesta</MenuItem>
                  <MenuItem value="Otro">Otro</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="caption" sx={{ fontWeight: 700, mb: 1, display: 'block', color: '#444' }}>Monto del subproducto</Typography>
              <TextField 
                fullWidth 
                size="small" 
                type="number"
                value={subproductForm.monto}
                onChange={(e) => setSubproductForm({...subproductForm, monto: parseFloat(e.target.value) || 0})}
              />
            </Grid>

            <Grid item xs={12}>
              <Typography variant="caption" sx={{ fontWeight: 700, mb: 1, display: 'block', color: '#444' }}>Tipo de moneda</Typography>
              <FormControl fullWidth size="small">
                <Select 
                  value={subproductForm.moneda}
                  onChange={(e) => setSubproductForm({...subproductForm, moneda: e.target.value})}
                >
                  <MenuItem value="$">$</MenuItem>
                  <MenuItem value="U$D">U$D</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="caption" sx={{ fontWeight: 700, mb: 1, display: 'block', color: '#444' }}>¿Incluye clasificación por colectivo?</Typography>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <FormControlLabel
                  control={
                    <Switch 
                      checked={subproductForm.clasificacionColectivo}
                      onChange={(e) => setSubproductForm({...subproductForm, clasificacionColectivo: e.target.checked})}
                      color="success"
                    />
                  }
                  label={subproductForm.clasificacionColectivo ? "SI" : "NO"}
                />
              </Box>
            </Grid>
          </Grid>

          <Box sx={{ mt: 4, display: 'flex', justifyContent: 'flex-end' }}>
            <Button 
              variant="contained" 
              sx={{ bgcolor: '#4caf50', '&:hover': { bgcolor: '#43a047' }, px: 4 }}
              onClick={() => {
                // Aquí iría la lógica de guardado
                console.log("Subproducto guardado:", subproductForm);
                setSubproductosDialogOpen(false);
              }}
            >
              GUARDAR
            </Button>
          </Box>
        </DialogContent>
      </Dialog>

      {/* MODAL DE CONTRATOS */}
      <Dialog 
        open={contratosDialogOpen} 
        onClose={() => setContratosDialogOpen(false)}
        maxWidth="lg"
        fullWidth
        PaperProps={{ sx: { borderRadius: 2 } }}
      >
        <DialogTitle sx={{ m: 0, p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Typography variant="h6" sx={{ color: '#666', fontSize: '1.1rem' }}>
              Contratos | {productoSeleccionado?.concepto?.toUpperCase()}
            </Typography>
            <Button 
              variant="contained" 
              size="small"
              sx={{ 
                bgcolor: palette.main, 
                '&:hover': { bgcolor: palette.main, filter: 'brightness(0.9)' },
                textTransform: 'none',
                borderRadius: 1.5,
                px: 2,
                fontSize: '0.8rem'
              }}
              onClick={() => {
                setContratoForm({ id: null, nombre: "", cuerpo: "" });
                setEditandoContrato(true);
              }}
            >
              Agregar contrato
            </Button>
          </Box>
          <IconButton onClick={() => setContratosDialogOpen(false)} size="small">
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ p: 0 }}>
          <Table size="small">
            <TableBody>
              <TableRow sx={{ bgcolor: '#fdfdfd', borderTop: '1px solid #eee' }}>
                <TableCell sx={{ color: '#666', fontWeight: 600, py: 1.5, px: 3, borderBottom: '1px solid #eee', width: '20%' }}>Acciones</TableCell>
                <TableCell sx={{ color: '#666', fontWeight: 600, py: 1.5, borderBottom: '1px solid #eee' }}>Nombre</TableCell>
              </TableRow>
              {contratos.map((c) => (
                <TableRow key={c.id}>
                  <TableCell sx={{ px: 3, py: 1.5 }}>
                    <Box sx={{ display: 'flex', gap: 1 }}>
                      <Tooltip title="vista previa" arrow>
                        <IconButton 
                          size="small" 
                          sx={{ color: palette.main, p: 0.5 }}
                          onClick={() => {
                            setContratoParaVistaPrevia(c);
                            setVistaPreviaDialogOpen(true);
                          }}
                        >
                          <Visibility sx={{ fontSize: 18 }} />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="editar" arrow>
                        <IconButton 
                          size="small" 
                          sx={{ color: palette.main, p: 0.5 }}
                          onClick={(e) => {
                            e.stopPropagation();
                            setContratoForm({ id: c.id, nombre: c.nombre, cuerpo: c.cuerpo });
                            setEditandoContrato(true);
                          }}
                        >
                          <DriveFileRenameOutline sx={{ fontSize: 18 }} />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="eliminar" arrow>
                        <IconButton 
                          size="small" 
                          sx={{ color: palette.main, p: 0.5 }}
                          onClick={() => {
                            setIdParaEliminar(c.id);
                            setConfirmarEliminarOpen(true);
                          }}
                        >
                          <RemoveCircle sx={{ fontSize: 18 }} />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="configurar pdf" arrow>
                        <IconButton 
                          size="small" 
                          sx={{ color: palette.main, p: 0.5 }}
                          onClick={(e) => {
                            e.stopPropagation();
                            setPdfSettingsDialogOpen(true);
                          }}
                        >
                          <Settings sx={{ fontSize: 18 }} />
                        </IconButton>
                      </Tooltip>
                    </Box>
                  </TableCell>
                  <TableCell sx={{ color: '#666', fontWeight: 500 }}>{c.nombre}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          <Box sx={{ height: 40 }} /> {/* Espacio inferior */}
        </DialogContent>
      </Dialog>

      {/* MODAL CONFIGURACIÓN PDF */}
      <Dialog 
        open={pdfSettingsDialogOpen} 
        onClose={() => setPdfSettingsDialogOpen(false)}
        maxWidth="xs"
        fullWidth
        PaperProps={{ sx: { borderRadius: 3, overflow: 'hidden' } }}
      >
        <Box sx={{ background: palette.gradient, p: 2, textAlign: 'center' }}>
          <Typography variant="h6" sx={{ color: 'white', fontWeight: 700 }}>
            Configuración de PDF
          </Typography>
        </Box>
        <DialogContent sx={{ p: 4 }}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <TextField 
                label="Margen Izquierdo (px)"
                type="number"
                fullWidth
                size="small"
                value={pdfSettings.margenIzquierdo}
                onChange={(e) => setPdfSettings({...pdfSettings, margenIzquierdo: parseInt(e.target.value) || 0})}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField 
                label="Margen Derecho (px)"
                type="number"
                fullWidth
                size="small"
                value={pdfSettings.margenDerecho}
                onChange={(e) => setPdfSettings({...pdfSettings, margenDerecho: parseInt(e.target.value) || 0})}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField 
                label="Tamaño de letra"
                type="number"
                fullWidth
                size="small"
                value={pdfSettings.tamanoLetra}
                onChange={(e) => setPdfSettings({...pdfSettings, tamanoLetra: parseInt(e.target.value) || 0})}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions sx={{ px: 4, pb: 4, pt: 0 }}>
          <Button 
            fullWidth 
            variant="contained" 
            sx={{ 
              bgcolor: palette.main, 
              '&:hover': { bgcolor: palette.main, filter: 'brightness(0.9)' },
              fontWeight: 700,
              borderRadius: 2,
              py: 1
            }}
            onClick={() => {
              console.log("Configuración PDF guardada:", pdfSettings);
              setPdfSettingsDialogOpen(false);
            }}
          >
            GUARDAR CONFIGURACIÓN
          </Button>
        </DialogActions>
      </Dialog>

      {/* MODAL EDITAR CONTRATO */}
      <Dialog 
        open={editandoContrato} 
        onClose={() => setEditandoContrato(false)}
        maxWidth="lg"
        fullWidth
        PaperProps={{ sx: { borderRadius: 2, bgcolor: '#f5f5f5' } }}
      >
        <DialogTitle sx={{ m: 0, p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center', bgcolor: 'white' }}>
          <Typography variant="h6" sx={{ color: '#666', fontSize: '1rem', fontWeight: 600 }}>
            Editar Contrato | {productoSeleccionado?.concepto?.toLowerCase()}
          </Typography>
          <IconButton onClick={() => setEditandoContrato(false)} size="small">
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ p: 3 }}>
          <Box sx={{ mb: 3 }}>
            <Typography variant="caption" sx={{ fontWeight: 700, mb: 0.5, display: 'block', color: '#444' }}>Nombre del contrato</Typography>
            <TextField 
              fullWidth 
              size="small" 
              value={contratoForm.nombre}
              onChange={(e) => setContratoForm({...contratoForm, nombre: e.target.value})}
              sx={{ bgcolor: 'white' }}
            />
          </Box>

          <Box sx={{ mb: 1 }}>
            <Typography variant="caption" sx={{ fontWeight: 700, mb: 0.5, display: 'block', color: '#444' }}>Cuerpo del contrato</Typography>
            
            {/* TOOLBAR DEL EDITOR */}
            <Box sx={{ border: '1px solid #ddd', borderRadius: '4px 4px 0 0', bgcolor: '#eee', p: 0.5, display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
               {/* Fila 1: Fuentes y Formato */}
               <Box sx={{ display: 'flex', gap: 0.5, mb: 0.5, width: '100%', pb: 0.5, borderBottom: '1px solid #ccc', flexWrap: 'wrap' }}>
                 <Tooltip title="Tipo de fuente" arrow>
                   <Select 
                    size="small" 
                    defaultValue="sans-serif" 
                    sx={{ height: 32, bgcolor: 'white', fontSize: '0.8rem', minWidth: 120 }}
                    onChange={(e) => ejecutarComando('fontName', e.target.value)}
                   >
                      {['sans-serif', 'Arial', 'Arial Black', 'Comic Sans MS', 'Courier New', 'Helvetica', 'Impact', 'Tahoma', 'Times New Roman', 'Verdana'].map(font => (
                        <MenuItem key={font} value={font} style={{ fontFamily: font }}>{font}</MenuItem>
                      ))}
                   </Select>
                 </Tooltip>
                 <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
                 <Tooltip title="Negrita" arrow>
                   <IconButton size="small" sx={{ bgcolor: 'white' }} onClick={() => ejecutarComando('bold')}><FormatBold fontSize="small" /></IconButton>
                 </Tooltip>
                 <Tooltip title="Cursiva" arrow>
                   <IconButton size="small" sx={{ bgcolor: 'white' }} onClick={() => ejecutarComando('italic')}><FormatItalic fontSize="small" /></IconButton>
                 </Tooltip>
                 <Tooltip title="Subrayado" arrow>
                   <IconButton size="small" sx={{ bgcolor: 'white' }} onClick={() => ejecutarComando('underline')}><FormatUnderlined fontSize="small" /></IconButton>
                 </Tooltip>
                 <Tooltip title="Borrar formato" arrow>
                   <IconButton size="small" sx={{ bgcolor: 'white' }} onClick={() => ejecutarComando('removeFormat')}><FormatClear fontSize="small" /></IconButton>
                 </Tooltip>
                 <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
                 <Tooltip title="Color texto" arrow>
                   <IconButton 
                    size="small" 
                    sx={{ bgcolor: 'white', position: 'relative' }} 
                    onClick={() => textColorRef.current?.click()}
                   >
                     <FormatColorText fontSize="small" />
                     <input 
                        type="color" 
                        ref={textColorRef} 
                        style={{ position: 'absolute', opacity: 0, width: '100%', height: '100%', cursor: 'pointer', left: 0, top: 0, padding: 0, border: 'none' }} 
                        onChange={(e) => ejecutarComando('foreColor', e.target.value)} 
                     />
                   </IconButton>
                 </Tooltip>
                 <Tooltip title="Resaltar" arrow>
                   <IconButton 
                    size="small" 
                    sx={{ bgcolor: 'white', position: 'relative' }} 
                    onClick={() => bgColorRef.current?.click()}
                   >
                     <FormatColorFill fontSize="small" />
                     <input 
                        type="color" 
                        ref={bgColorRef} 
                        style={{ position: 'absolute', opacity: 0, width: '100%', height: '100%', cursor: 'pointer', left: 0, top: 0, padding: 0, border: 'none' }} 
                        onChange={(e) => ejecutarComando('hiliteColor', e.target.value)} 
                     />
                   </IconButton>
                 </Tooltip>
                 <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
                 <Tooltip title="Alinear izquierda" arrow>
                   <IconButton size="small" sx={{ bgcolor: 'white' }} onClick={() => ejecutarComando('justifyLeft')}><FormatAlignLeft fontSize="small" /></IconButton>
                 </Tooltip>
                 <Tooltip title="Alinear centro" arrow>
                   <IconButton size="small" sx={{ bgcolor: 'white' }} onClick={() => ejecutarComando('justifyCenter')}><FormatAlignCenter fontSize="small" /></IconButton>
                 </Tooltip>
                 <Tooltip title="Alinear derecha" arrow>
                   <IconButton size="small" sx={{ bgcolor: 'white' }} onClick={() => ejecutarComando('justifyRight')}><FormatAlignRight fontSize="small" /></IconButton>
                 </Tooltip>
                 <Tooltip title="Justificar" arrow>
                   <IconButton size="small" sx={{ bgcolor: 'white' }} onClick={() => ejecutarComando('justifyFull')}><FormatAlignJustify fontSize="small" /></IconButton>
                 </Tooltip>
                 <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
                 <Tooltip title="Lista viñetas" arrow>
                   <IconButton size="small" sx={{ bgcolor: 'white' }} onClick={() => ejecutarComando('insertUnorderedList')}><FormatListBulleted fontSize="small" /></IconButton>
                 </Tooltip>
                 <Tooltip title="Lista números" arrow>
                   <IconButton size="small" sx={{ bgcolor: 'white' }} onClick={() => ejecutarComando('insertOrderedList')}><FormatListNumbered fontSize="small" /></IconButton>
                 </Tooltip>
                 <Tooltip title="Reducir sangría" arrow>
                   <IconButton size="small" sx={{ bgcolor: 'white' }} onClick={() => ejecutarComando('outdent')}><FormatIndentDecrease fontSize="small" /></IconButton>
                 </Tooltip>
                 <Tooltip title="Aumentar sangría" arrow>
                   <IconButton size="small" sx={{ bgcolor: 'white' }} onClick={() => ejecutarComando('indent')}><FormatIndentIncrease fontSize="small" /></IconButton>
                 </Tooltip>
                 <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
                 <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
                 <Tooltip title="Insertar tabla" arrow>
                   <IconButton 
                    size="small" 
                    sx={{ bgcolor: 'white' }} 
                    onClick={(e) => setAnchorElTable(e.currentTarget)}
                   >
                     <TableChart fontSize="small" />
                   </IconButton>
                 </Tooltip>

                 <Popover
                  open={Boolean(anchorElTable)}
                  anchorEl={anchorElTable}
                  onClose={() => setAnchorElTable(null)}
                  anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                 >
                  <Box sx={{ p: 2, bgcolor: 'white' }}>
                    <Typography variant="caption" sx={{ display: 'block', mb: 1, fontWeight: 700, textAlign: 'center' }}>
                      {hoverTableSize.r > 0 ? `${hoverTableSize.r} x ${hoverTableSize.c}` : 'Seleccione tamaño'}
                    </Typography>
                    <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(10, 20px)', gap: '2px' }}>
                      {[...Array(10)].map((_, r) => (
                        [...Array(10)].map((_, c) => (
                          <Box 
                            key={`${r}-${c}`}
                            onMouseEnter={() => setHoverTableSize({ r: r + 1, c: c + 1 })}
                            onClick={() => confirmarInsertarTabla(r + 1, c + 1)}
                            sx={{ 
                              width: 20, 
                              height: 20, 
                              border: '1px solid #ddd',
                              cursor: 'pointer',
                              bgcolor: (r < hoverTableSize.r && c < hoverTableSize.c) ? palette.main : 'white',
                              transition: 'background-color 0.1s'
                            }}
                          />
                        ))
                      ))}
                    </Box>
                  </Box>
                 </Popover>
               </Box>
               
               {/* Fila 2: Tags Datos */}
               <Box sx={{ display: 'flex', gap: 0.5, mb: 0.5, width: '100%', pb: 0.5, borderBottom: '1px solid #ccc', flexWrap: 'wrap' }}>
                 {[
                   'Colegio', 'Nombre', 'Apellido', 'DNI', 'Fecha Nacimiento', 'Dirección', 
                   'Teléfono', 'Fecha de Firma', 'Nombre Padre', 'DNI Padre', 'Dirección Padre'
                 ].map(tag => (
                   <Button 
                    key={tag} 
                    size="small" 
                    variant="outlined" 
                    sx={{ textTransform: 'none', fontSize: '0.7rem', bgcolor: 'white', borderColor: '#ccc', color: '#444', px: 1, height: 28 }}
                    onClick={() => ejecutarComando('insertHTML', `<b>{${tag}}</b>`)}
                   >
                     {tag}
                   </Button>
                 ))}
               </Box>

               {/* Fila 3: Tags Montos */}
               <Box sx={{ display: 'flex', gap: 0.5, width: '100%', flexWrap: 'wrap' }}>
                 {[
                   'Monto a pagar', 'Monto en letras', 'Monto suplementario', 'Suplementario en letras'
                 ].map(tag => (
                   <Button 
                    key={tag} 
                    size="small" 
                    variant="outlined" 
                    sx={{ textTransform: 'none', fontSize: '0.7rem', bgcolor: 'white', borderColor: '#ccc', color: '#444', px: 1, height: 28 }}
                    onClick={() => ejecutarComando('insertHTML', `<b>{${tag}}</b>`)}
                   >
                     {tag}
                   </Button>
                 ))}
               </Box>
            </Box>

            {/* AREA DEL EDITOR (ContentEditable para soporte real de estilos) */}
            <Box
              contentEditable
              ref={editorRef}
              onInput={(e: any) => {
                // Actualizamos el estado interno sin forzar un re-render del DOM del editor
                contratoForm.cuerpo = e.currentTarget.innerHTML;
              }}
              sx={{ 
                minHeight: 400,
                maxHeight: 600,
                overflowY: 'auto',
                border: '1px solid #ddd',
                borderRadius: '0 0 4px 4px', 
                bgcolor: 'white',
                p: 3,
                outline: 'none',
                fontSize: '0.85rem',
                lineHeight: 1.6,
                fontFamily: 'serif',
                '&:focus': { borderColor: palette.main, boxShadow: `0 0 0 1px ${palette.main}22` },
                '& table': { width: '100%', borderCollapse: 'collapse', mb: 2 },
                '& td': { border: '1px solid #ccc', p: 1 }
              }}
              // Usamos dangerouslySetInnerHTML solo para la carga inicial o cambios externos
              dangerouslySetInnerHTML={{ __html: contratoForm.id ? contratos.find(c => c.id === contratoForm.id)?.cuerpo : "" }}
            />
          </Box>
          
          <Box sx={{ mt: 2 }}>
            <Button 
              variant="contained" 
              sx={{ 
                bgcolor: '#4caf50', 
                '&:hover': { bgcolor: '#43a047' }, 
                textTransform: 'none',
                fontWeight: 600,
                px: 3
              }}
              onClick={() => {
                if (contratoForm.id) {
                  // Editar existente
                  setContratos(contratos.map(c => c.id === contratoForm.id ? { ...contratoForm } : c));
                } else {
                  // Nuevo contrato
                  const nuevo = { ...contratoForm, id: Date.now() };
                  setContratos([...contratos, nuevo]);
                }
                setEditandoContrato(false);
              }}
            >
              {contratoForm.id ? "Guardar cambios" : "Crear contrato"}
            </Button>
          </Box>
        </DialogContent>
      </Dialog>

      {/* MODAL VISTA PREVIA CONTRATO */}
      <Dialog 
        open={vistaPreviaDialogOpen} 
        onClose={() => setVistaPreviaDialogOpen(false)}
        maxWidth="md"
        fullWidth
        PaperProps={{ sx: { borderRadius: 3 } }}
      >
        <DialogTitle sx={{ m: 0, p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #eee' }}>
          <Typography variant="h6" sx={{ color: palette.main, fontWeight: 700 }}>
            Vista Previa | {contratoParaVistaPrevia?.nombre}
          </Typography>
          <IconButton onClick={() => setVistaPreviaDialogOpen(false)} size="small">
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ p: 4 }}>
          <Box 
            sx={{ 
              p: 4, 
              bgcolor: 'white', 
              boxShadow: '0 0 10px rgba(0,0,0,0.1)', 
              borderRadius: 1,
              fontFamily: 'serif',
              fontSize: `${pdfSettings.tamanoLetra}pt`,
              lineHeight: 1.6,
              minHeight: '600px',
              color: '#333'
            }}
            dangerouslySetInnerHTML={{ __html: contratoParaVistaPrevia?.cuerpo }}
          />
        </DialogContent>
        <DialogActions sx={{ p: 3, borderTop: '1px solid #eee' }}>
          <Button 
            variant="outlined" 
            onClick={() => setVistaPreviaDialogOpen(false)}
            sx={{ color: '#666', borderColor: '#ccc', textTransform: 'none' }}
          >
            Cerrar
          </Button>
          <Button 
            variant="contained" 
            startIcon={<Print />}
            sx={{ bgcolor: palette.main, '&:hover': { bgcolor: palette.main, filter: 'brightness(0.9)' }, textTransform: 'none' }}
            onClick={() => window.print()}
          >
            Imprimir Contrato
          </Button>
        </DialogActions>
      </Dialog>

      {/* MODAL CONFIRMAR ELIMINACIÓN */}
      <Dialog 
        open={confirmarEliminarOpen} 
        onClose={() => setConfirmarEliminarOpen(false)}
        PaperProps={{ sx: { borderRadius: 3 } }}
      >
        <DialogTitle sx={{ textAlign: 'center', pt: 3 }}>
          <Typography variant="h5" sx={{ fontWeight: 800, color: '#444' }}>¿Estás seguro?</Typography>
        </DialogTitle>
        <DialogContent sx={{ textAlign: 'center', px: 4 }}>
          <Typography sx={{ color: '#666' }}>
            Esta acción no se puede deshacer. El contrato será eliminado permanentemente.
          </Typography>
        </DialogContent>
        <DialogActions sx={{ p: 3, justifyContent: 'center', gap: 2 }}>
          <Button 
            onClick={() => setConfirmarEliminarOpen(false)}
            variant="outlined"
            sx={{ textTransform: 'none', borderRadius: 2, px: 3, borderColor: '#ddd', color: '#666' }}
          >
            Cancelar
          </Button>
          <Button 
            onClick={() => {
              setContratos(contratos.filter(c => c.id !== idParaEliminar));
              setConfirmarEliminarOpen(false);
            }}
            variant="contained"
            sx={{ 
              bgcolor: '#d32f2f', 
              '&:hover': { bgcolor: '#b71c1c' },
              textTransform: 'none', 
              borderRadius: 2,
              px: 3,
              fontWeight: 700
            }}
          >
            Sí, eliminar
          </Button>
        </DialogActions>
      </Dialog>

      {/* MODAL CONFIRMAR FINALIZACIÓN */}
      <Dialog 
        open={confirmarFinalizarOpen} 
        onClose={() => setConfirmarFinalizarOpen(false)}
        PaperProps={{ sx: { borderRadius: 3 } }}
      >
        <DialogTitle sx={{ textAlign: 'center', pt: 3 }}>
          <Typography variant="h5" sx={{ fontWeight: 800, color: '#444' }}>¿Finalizar producto?</Typography>
        </DialogTitle>
        <DialogContent sx={{ textAlign: 'center', px: 4 }}>
          <Typography sx={{ color: '#666' }}>
            El producto pasará a la lista de "Finalizados". Esta acción es necesaria para cerrar el ciclo de venta.
          </Typography>
        </DialogContent>
        <DialogActions sx={{ p: 3, justifyContent: 'center', gap: 2 }}>
          <Button 
            onClick={() => setConfirmarFinalizarOpen(false)}
            variant="outlined"
            sx={{ textTransform: 'none', borderRadius: 2, px: 3, borderColor: '#ddd', color: '#666' }}
          >
            Cancelar
          </Button>
          <Button 
            onClick={() => {
              onFinalizar(productoSeleccionado.id);
              setConfirmarFinalizarOpen(false);
            }}
            variant="contained"
            sx={{ 
              bgcolor: '#4caf50', 
              '&:hover': { bgcolor: '#43a047' },
              textTransform: 'none', 
              borderRadius: 2,
              px: 3,
              fontWeight: 700
            }}
          >
            Confirmar
          </Button>
        </DialogActions>
      </Dialog>

      {/* MODAL EXPORTAR A EXCEL (Fiel al diseño) */}
      <Dialog 
        open={exportDialogOpen} 
        onClose={() => setExportDialogOpen(false)}
        maxWidth="lg"
        fullWidth
        PaperProps={{ sx: { borderRadius: 0 } }} // Diseño cuadrado como en la imagen
      >
        <DialogTitle sx={{ m: 0, p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #ddd' }}>
          <Typography sx={{ fontWeight: 600, color: '#444' }}>Exportar a Excel</Typography>
          <IconButton onClick={() => setExportDialogOpen(false)} size="small">
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ p: 4 }}>
          <Box sx={{ mb: 4 }}>
            <Typography variant="body2" sx={{ mb: 1, color: '#333', fontWeight: 600 }}>Colectivos:</Typography>
            <FormControl fullWidth size="small">
              <Select
                value={colectivoSeleccionado}
                onChange={(e) => setColectivoSeleccionado(e.target.value)}
                sx={{ bgcolor: '#fff' }}
              >
                <MenuItem value="Todos">Todos</MenuItem>
                <MenuItem value="Colectivo 1">Colectivo 1</MenuItem>
                <MenuItem value="Colectivo 2">Colectivo 2</MenuItem>
              </Select>
            </FormControl>
          </Box>

          <Typography variant="body2" sx={{ mb: 3, color: '#333', fontWeight: 600 }}>
            Seleccione los datos que requiere exportar
          </Typography>

          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 4 }}>
            <Button 
                variant="contained" 
                size="small"
                sx={{ 
                  bgcolor: palette.main, 
                  '&:hover': { bgcolor: palette.main, filter: 'brightness(0.9)' },
                  textTransform: 'none',
                  borderRadius: 0,
                  fontSize: '0.75rem',
                  minWidth: 140,
                  height: 36
                }}
                onClick={handleToggleTodo}
              >
                Seleccionar Todos
              </Button>
          </Box>

          <Grid container spacing={1}>
            {EXPORT_FIELDS.map((campo) => {
              const seleccionado = camposSeleccionados.includes(campo);
              return (
                <Grid item xs={1.71} key={campo}>
                  <Button 
                    fullWidth
                    variant="contained"
                    size="small"
                    onClick={() => {
                      if (seleccionado) setCamposSeleccionados(camposSeleccionados.filter(c => c !== campo));
                      else setCamposSeleccionados([...camposSeleccionados, campo]);
                    }}
                    sx={{ 
                      bgcolor: seleccionado ? palette.main : '#f3f0f7', 
                      color: seleccionado ? 'white' : '#666',
                      '&:hover': { bgcolor: palette.main, color: 'white', filter: 'brightness(0.9)' },
                      textTransform: 'none',
                      borderRadius: 0,
                      fontSize: '0.7rem',
                      height: 40,
                      boxShadow: 'none',
                      border: `1px solid ${seleccionado ? 'transparent' : '#e0d8e8'}`
                    }}
                  >
                    {campo}
                  </Button>
                </Grid>
              );
            })}
          </Grid>
        </DialogContent>
        <DialogActions sx={{ p: 0, display: 'flex' }}>
          <Button 
            fullWidth
            onClick={() => setExportDialogOpen(false)}
            sx={{ 
              bgcolor: '#e55353', 
              color: 'white', 
              '&:hover': { bgcolor: '#c43d3d' },
              borderRadius: 0,
              height: 50,
              textTransform: 'none',
              fontWeight: 700,
              fontSize: '1.1rem'
            }}
          >
            Cancelar
          </Button>
          <Button 
            fullWidth
            onClick={handleExportarExcel}
            sx={{ 
              bgcolor: '#66bb6a', 
              color: 'white', 
              '&:hover': { bgcolor: '#43a047' },
              borderRadius: 0,
              height: 50,
              textTransform: 'none',
              fontWeight: 700,
              fontSize: '1.1rem'
            }}
          >
            Exportar
          </Button>
        </DialogActions>
      </Dialog>
    </Dialog>
  );
};
